import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseDatatableHeaderComponent } from 'app/shared/components/table/components/table/base-datatable-header.component';

@Component({
  selector: 'app-status-filter-header',
  template: `
    <div class="flex items-center justify-end w-full h-full">
      <app-button-multi-select
        [options]="options"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        (select)="onSelect($event)"
      />
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: auto;
        margin-left: auto;
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        pointer-events: none;
      }

      :host > div {
        pointer-events: auto;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusFilterHeaderComponent extends BaseDatatableHeaderComponent {
  get options() {
    return this.colDef().custonConfig?.['options'] ?? [];
  }

  get optionLabel() {
    return this.colDef().custonConfig?.['optionLabel'] ?? 'label';
  }

  get optionValue() {
    return this.colDef().custonConfig?.['optionValue'] ?? 'value';
  }

  onSelect(event: string[]) {
    const keyFilter = this.colDef().custonConfig?.['keyFilter'] ?? 'status';
    this.onFilterChange()({ [keyFilter]: event });
  }
}
